import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Download, FileText } from 'lucide-react';

const DocsInternos = () => {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/docs-internos`)
      .then((r) => r.json())
      .then((data) => setDocs(data.items || []))
      .catch(() => setDocs([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-sm text-ink-500">Cargando documentos…</div>;
  if (!docs.length) return <div className="text-sm text-ink-500">No hay documentos disponibles.</div>;

  const grupos = {};
  docs.forEach((d) => {
    const base = d.slug.replace(/\.(pdf|md)$/, '');
    if (!grupos[base]) grupos[base] = { titulo: d.titulo.replace(/ \(Markdown\)$/, ''), pdf: null, md: null };
    grupos[base][d.tipo] = d;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="docs-internos-listado">
      {Object.entries(grupos).map(([base, g]) => (
        <div key={base} className="flex items-center justify-between gap-3 p-3 rounded-lg border border-ink-200 bg-white hover:shadow-sm transition-shadow">
          <div className="min-w-0 flex-1">
            <div className="font-medium text-ink-900 text-sm truncate">{g.titulo}</div>
            <div className="text-xs text-ink-500 mt-0.5">
              {g.pdf && <span>PDF · {g.pdf.size_kb} KB</span>}
              {g.pdf && g.md && <span className="mx-1">·</span>}
              {g.md && <span>Markdown · {g.md.size_kb} KB</span>}
            </div>
          </div>
          <div className="flex gap-1.5 shrink-0">
            {g.pdf && (
              <a href={`${process.env.REACT_APP_BACKEND_URL}${g.pdf.download_url}`} target="_blank" rel="noreferrer" data-testid={`btn-pdf-${base}`}>
                <Button size="sm" className="bg-brand-500 hover:bg-brand-600 text-white h-8 px-3">
                  <Download className="w-3.5 h-3.5 mr-1" /> PDF
                </Button>
              </a>
            )}
            {g.md && (
              <a href={`${process.env.REACT_APP_BACKEND_URL}${g.md.download_url}`} target="_blank" rel="noreferrer" data-testid={`btn-md-${base}`}>
                <Button size="sm" variant="outline" className="h-8 px-3">
                  <FileText className="w-3.5 h-3.5 mr-1" /> MD
                </Button>
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocsInternos;
